import Link from 'next/link';
import Text from '@deprecated-ui/common/Text';
import { VerticalMenu } from './styled';

const CustomVerticalMenu = ({
  selectedMenu,
  verticalMenuItems,
}: {
  selectedMenu: string;
  verticalMenuItems: string[];
}) => (
  // @ts-expect-error
  <VerticalMenu defaultSelectedKeys={selectedMenu} selectedKeys={selectedMenu}>
    {verticalMenuItems.map((menu: string) => {
      let path = '/calendar';
      if (menu !== 'Today') {
        path += `/${menu.toLowerCase()}`.replace(/ /g, '');
      }
      return (
        <VerticalMenu.Item key={menu}>
          <Link href={path} passHref>
            <Text color="inherit" align="center" padding="8px 5px">
              {menu}
            </Text>
          </Link>
        </VerticalMenu.Item>
      );
    })}
  </VerticalMenu>
);

export default CustomVerticalMenu;
